import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
import THead from './THead';
import { IData } from '../../helpers/interface';
import TFoot from './TFoot';

interface IProps {
  moduleData: IData;
  isView: boolean;
  setUseEffectRender: any;
  handelDeleteRows: any;
  setIsOpenPopupRejections: any;
  setRejectionsIndx: any;
  setIsOpenPopupForScheduleDowntime: any;
  setIsOpenPopup: any;
  setPartIdx: any;
  setMachineId: any;
  machineId: any;
}

const TController = ({
  moduleData,
  isView,
  handelDeleteRows,
  setUseEffectRender,
  setIsOpenPopupForScheduleDowntime,
  setIsOpenPopup,
  setPartIdx,
  setIsOpenPopupRejections,
  setRejectionsIndx,
  setMachineId,
  machineId,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            setUseEffectRender,
            setMachineId,
            machineId,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
            handelDeleteRows,
            setIsOpenPopupRejections,
            setIsOpenPopupForScheduleDowntime,
            setRejectionsIndx,
            setIsOpenPopup,
            setPartIdx,
          }}
        />
        <TFoot {...{ moduleData, isView }} />
      </RenderTable>
    </Box>
  );
};

export default TController;
